import { useModal } from '@shared/model/useModal';

export const useTeacherStudentsListModal = () => useModal('teacher-students-list');
